module.exports = __webpack_public_path__ + "img/collaborate-right-jewelry.12568ce0.svg";